import React from "react";
import { Result, Button } from "antd";
import { withRouter } from "react-router";

const NotFound = ({ history }) => (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, you don't have access to this page, or it doesn't exist."
    extra={
      <Button
        type="primary"
        onClick={() => history.push(`${process.env.PUBLIC_URL}/dashboard`)}
      >
        Back to Dashboard
      </Button>
    }
  />
);

export default withRouter(NotFound);
